"use strict";

const m = require("mithril");

const css = require("./footer.css");

const ratings = {
    gw : {
        label     : "PEGI",
        className : css.pegi
    },
    gw2 : {
        label     : "PEGI 16",
        className : css.pegi16
    },
    gw3 : {
        label     : "PEGI",
        className : css.pegi
    }
};


module.exports = {
    view({ attrs }) {
        const { label, className } = ratings[attrs.gameCode] || ratings.gw;

        return m("div",
            {
                class       : css.rating,
                "data-test" : "pegi-rating"
            },
            m("a", {
                    class  : className,
                    href   : "https://www.pegi.info",
                    target : "_blank"
                },
                label
            )
        );
    }
};
